module.exports = __webpack_public_path__ + "static/media/add-vendors.b677b5d5.svg";